import { AppstoreOutlined, BankOutlined, CalendarOutlined, CameraOutlined, CaretRightOutlined, ClockCircleFilled, ClockCircleOutlined, CloseCircleFilled, CloseCircleOutlined, CoffeeOutlined, DoubleRightOutlined, EditOutlined, FileTextOutlined, FontSizeOutlined, ForwardOutlined, GlobalOutlined, HomeOutlined, LoadingOutlined, MinusOutlined, PercentageOutlined, PhoneOutlined, PictureOutlined, PlusOutlined, PlusSquareOutlined, ReadOutlined, ShopOutlined, ShoppingOutlined, SoundFilled, SoundOutlined, StopOutlined, SyncOutlined, TagOutlined, TeamOutlined, ToolOutlined, UsergroupAddOutlined, WarningOutlined } from '@ant-design/icons';
import { Drawer, Spin, Tag, Timeline, Tooltip } from 'antd';
import { useState,  useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { useFetch } from '../../../../../hooks/useFetch/useFetch';
import { DrawerContext } from '../../../../../store/DrawerContext/DrawerContext';
import moment from 'moment';
import { useAuth } from '../../../../../store/AuthContext/AuthContext';
import { Operations } from './Operations';
import { DrawerPanelTitle, drawerPanelStyles } from '../../Drawers/DrawerPanelTitle';

const iconStyle = { fontSize: '17px' };

const iconMap: Record<string, React.ReactNode> = {

  // --- PUBLICACIONES ---
  'STANDARD': <SoundOutlined style={iconStyle} />,                  // Publicación / Novedad
  'EVENT': <SoundOutlined style={iconStyle} />,                  // Evento
  'OFFER': <SoundOutlined style={iconStyle} />,                       // Oferta

  // --- EDICIONES ---
  'EDIT_LOGO': <PictureOutlined style={iconStyle} />,                  // Logo
  'EDIT_COVER': <PictureOutlined style={iconStyle} />,                 // Portada
  'EDIT_NAME': <FontSizeOutlined style={iconStyle} />,              // Nombre
  'EDIT_DESCRIPTION': <FontSizeOutlined style={iconStyle} />,       // Descripción
  'EDIT_PHONE': <PhoneOutlined style={iconStyle} />,                // Teléfono
  'EDIT_PHONES': <PhoneOutlined style={iconStyle} />,               // Teléfonos
  'EDIT_WEB': <GlobalOutlined style={iconStyle} />,                 // Web
  'EDIT_CATEGORIES': <AppstoreOutlined style={iconStyle} />,        // Categorías
  'EDIT_REGULAR_HOURS': <ClockCircleOutlined style={iconStyle} />,  // Horarios
  'EDIT_SHIFT': <ClockCircleOutlined style={iconStyle} />,          // Horario (Deprecated)
  'EDIT_ADD_SPECIAL_HOURS': <CalendarOutlined style={iconStyle} />,   // Añadir festivo
  'EDIT_REMOVE_SPECIAL_HOURS': <CalendarOutlined style={iconStyle} />,// Eliminar festivo

  // --- FOTOGRAFÍAS --- 
  'PHOTO_ADITIONAL': <PictureOutlined style={iconStyle} />,         // Logo
  'PHOTO_LOGO': <PictureOutlined style={iconStyle} />,              // Logo
  'PHOTO_COVER': <PictureOutlined style={iconStyle} />,             // Portada
  'PHOTO_EXTERIOR': <PictureOutlined style={iconStyle} />,             // Exterior
  'PHOTO_INTERIOR': <PictureOutlined style={iconStyle} />,             // Interior
  'PHOTO_PRODUCT': <PictureOutlined style={iconStyle} />,          // Producto
  'PHOTO_AT_WORK': <PictureOutlined style={iconStyle} />,              // En el trabajo
  'PHOTO_FOOD_AND_DRINK': <PictureOutlined style={iconStyle} />,     // Comida y bebida
  'PHOTO_MENU': <PictureOutlined style={iconStyle} />,                 // Menú
  'PHOTO_COMMON_AREA': <PictureOutlined style={iconStyle} />,           // Áreas comunes
  'PHOTO_ROOMS': <PictureOutlined style={iconStyle} />,                // Habitaciones
  'PHOTO_TEAMS': <PictureOutlined style={iconStyle} />,                // Equipo
  'PHOTO_ADDITIONAL': <PictureOutlined style={iconStyle} />,     // Imágenes adicionales
};

const statusMap: any = {
  'NOT_FINISHED': {name: 'Pregunta', color:'Orange'},  
  'RUNNING': {name: 'Empezado', color:'black'}, 
  'Running': {name: 'Empezado', color:'black'},  
  'FINISHED_KO': {name: 'Error', color:'MediumVioletRed'},
  'FINISHED_OK': {name: 'Finalizado', color:'green'}
};

export const LogsDrawer = () => {

  const { t } = useTranslation();
  const [updateData, setUpdateData] = useState(false);  
  const [job, setJob] = useState(null);
  const [jobsData, setJobsData] = useState([]);
  const { projectGroup } = useAuth();
  const { logsDrawer, setLogsDrawer } = useContext(DrawerContext);

  const {isLoading } = useFetch(`${process.env.REACT_APP_API}/projects/` + projectGroup.project + '/jobs', {}, [updateData], (data) => {
    setJobsData(data.jobs);    
    // setTimeout(() => {
    //   setUpdateData(!updateData);
    // }, 5000);		
  });    

  return (
    <Drawer title={
      <DrawerPanelTitle
        title="Registro de Operaciones Masivas"
        isProject={true}
      />
      }  
      placement="right" 
      width={'50%'} 
      {...drawerPanelStyles}
      onClose={()=>setLogsDrawer(false)} 
      open={logsDrawer}>
     { 
      isLoading ? <div style={{display:'flex', justifyContent:'center', alignItems:'center', height: '100%'}}><Spin indicator={<LoadingOutlined style={{ fontSize: 24 }} spin />} /></div> : 
      <div style={{padding:'0px 10px'}}>        
      <br/>
        <Timeline mode={'left'}>
          {
            jobsData.map((row : any) => {
              const icon = row.status === 'RUNNING' ? <SyncOutlined spin /> : row.status === 'NOT_FINISHED' ? <Tooltip title={<>El proceso ha sido interrumpido</>}><CloseCircleOutlined   /></Tooltip> : iconMap[row.statusAction];            
              return (
                <Timeline.Item 
                  color={statusMap[row.status].color}                                       
                  dot={icon}>

                    <div style={{display:'flex', justifyContent:'space-between'}}>
                      <div>
                        <b>{row.action}</b>                         
                        
                        {!row.accountPath || row.accountPath.includes(',') ? 
                          <small style={{marginLeft: '5px', color:'grey', background: 'ivory', padding: '2px 5px', borderRadius: '5px' }}>Todos los grupos</small>
                          :
                          <small style={{marginLeft: '5px', color:'grey', background: '#e6e6fa', padding: '2px 5px', borderRadius: '5px' }}>{row.groupName}</small>
                        }
                   
                      
                      </div>
                      <b><a style={{fontSize:'12px'}} onClick={() => {setJob(row)}}>En {row.operations} {t('dictionary.shops').toLowerCase()}{' >>'}</a></b>
                    </div>                     
                    <i style={{color:'grey', margin:0}}>{moment(row.created).format('ll')} por {row.operatorName}</i>
                    
                </Timeline.Item>
                )
              })
            }                    
      </Timeline>
    </div>
    }
    
    {
      job && <Operations job={job} onFinish={() => setJob(null)}/>      
    }
  </Drawer>
	)
}